import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, reactive, watch } from "vue";
import { ElMessage, ElLoading } from "element-plus";
import { login } from "@/api/login";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Login',
    props: {
        visible: { type: Boolean }
    },
    emits: ["update:visible"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const dialogVisible = ref(props.visible);
        const formRef = ref();
        const loginForm = reactive({
            username: "",
            password: "",
        });
        const rules = {
            username: [
                { required: true, message: "请输入账号", trigger: "blur" },
                { min: 3, max: 20, message: "账号长度为3-20位", trigger: "blur" },
            ],
            password: [
                { required: true, message: "请输入密码", trigger: "blur" },
                { min: 6, max: 20, message: "密码长度为6-20位", trigger: "blur" },
            ],
        };
        const handleLogin = () => {
            formRef.value?.validate(async (valid) => {
                if (valid) {
                    const loading = ElLoading.service({ text: "登录中..." });
                    try {
                        const res = await login(loginForm);
                        if (res.data && res.data.token) {
                            localStorage.setItem("token", res.data.token);
                            ElMessage.success("登录成功");
                            dialogVisible.value = false;
                            emit("update:visible", false);
                        }
                    }
                    catch (error) {
                        ElMessage.error("登录失败");
                    }
                    finally {
                        loading.close();
                    }
                }
            });
        };
        const handleClose = () => {
            dialogVisible.value = false;
            emit("update:visible", false);
        };
        watch(() => props.visible, (newVal) => {
            dialogVisible.value = newVal;
            if (!newVal) {
                loginForm.username = "";
                loginForm.password = "";
                formRef.value?.resetFields();
            }
        });
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_form_item = _resolveComponent("el-form-item");
            const _component_el_form = _resolveComponent("el-form");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                modelValue: dialogVisible.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((dialogVisible).value = $event)),
                title: "登录",
                width: "400px",
                "before-close": handleClose,
                "close-on-click-modal": false,
                center: ""
            }, {
                footer: _withCtx(() => [
                    _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: handleLogin
                    }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createTextVNode("登录", -1)
                            ]))]),
                        _: 1
                    }),
                    _createVNode(_component_el_button, { onClick: handleClose }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("取消", -1)
                            ]))]),
                        _: 1
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                        model: loginForm,
                        rules: rules,
                        ref_key: "formRef",
                        ref: formRef,
                        "label-width": "80px"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_el_form_item, {
                                label: "账号",
                                prop: "username"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                        modelValue: loginForm.username,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((loginForm.username) = $event)),
                                        placeholder: "请输入账号"
                                    }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                                label: "密码",
                                prop: "password"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                        modelValue: loginForm.password,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((loginForm.password) = $event)),
                                        type: "password",
                                        placeholder: "请输入密码",
                                        "show-password": ""
                                    }, null, 8, ["modelValue"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["model"])
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});
